import type { SkinnyBannerProps } from "./SkinnyBanner.types";
import {
  BANNER_HEIGHT,
  BOLD_FONT_WEIGHT,
  BORDER_COLOR,
  BORDER_RADIUS,
  BOX_SHADOW,
  CONTENT_GAP,
  LOGO_SIZE,
  MOBILE_PADDING_RIGHT,
  MOBILE_TEXT_FONT_SIZE,
  REGULAR_FONT_WEIGHT,
  SKINNY_BANNER_TABLET_MIN_WIDTH,
  TABLET_PADDING_X,
  TABLET_TEXT_FONT_SIZE,
  TEXT_COLOR,
} from "./SkinnyBanner.tokens";

const ROOT_CLASS = "fd-skinny-banner";
const TEXT_CLASS = "fd-skinny-banner__text";

const RESPONSIVE_STYLES = `
.${ROOT_CLASS}{padding-right:${MOBILE_PADDING_RIGHT}px;}
.${TEXT_CLASS}{width:100%;font-size:${MOBILE_TEXT_FONT_SIZE}px;}
@media (min-width:${SKINNY_BANNER_TABLET_MIN_WIDTH}px){
.${ROOT_CLASS}{padding-left:${TABLET_PADDING_X}px;padding-right:${TABLET_PADDING_X}px;min-height:${BANNER_HEIGHT}px;justify-content:center;}
.${TEXT_CLASS}{width:auto;font-size:${TABLET_TEXT_FONT_SIZE}px;}
}
`;

export const SkinnyBanner = (props: SkinnyBannerProps) => {
  const {
    backgroundImageUrl,
    logoImageUrl,
    text,
    textColor = TEXT_COLOR,
    borderColor = BORDER_COLOR,
    hasBoldText = false,
    testId,
    style,
    className,
    ...rest
  } = props;

  if (!backgroundImageUrl) {
    return null;
  }

  return (
    <>
      <style>{RESPONSIVE_STYLES}</style>
      <div
        {...rest}
        className={className ? `${ROOT_CLASS} ${className}` : ROOT_CLASS}
        data-testid={testId}
        style={{
          position: "relative",
          width: "100%",
          border: `1px solid ${borderColor}`,
          borderRadius: BORDER_RADIUS,
          boxShadow: BOX_SHADOW,
          backgroundImage: `url(${backgroundImageUrl})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          display: "inline-flex",
          verticalAlign: "top",
          alignItems: "center",
          gap: CONTENT_GAP,
          height: BANNER_HEIGHT,
          ...style,
        }}
      >
        {logoImageUrl ? (
          <img
            src={logoImageUrl}
            alt=""
            data-testid={`${testId}-logo`}
            style={{
              width: LOGO_SIZE,
              height: LOGO_SIZE,
              objectFit: "contain",
              flexShrink: 0,
            }}
          />
        ) : null}
        {text ? (
          <span
            data-testid={`${testId}-text`}
            className={TEXT_CLASS}
            style={{
              color: textColor,
              fontWeight: hasBoldText ? BOLD_FONT_WEIGHT : REGULAR_FONT_WEIGHT,
              lineHeight: 1.25,
              minWidth: 0,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
            }}
          >
            {text}
          </span>
        ) : null}
      </div>
    </>
  );
};
